import React, { useEffect } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { LeadSection } from '../components/sales/LeadSection';
import { PainSection } from '../components/sales/PainSection';
import { TwistSection } from '../components/sales/TwistSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { CTASection } from '../components/sales/CTASection';
import { Footer } from '../components/sales/Footer';
import { initMetaPixel } from '../lib/metaPixel';
import { CurrencyProvider } from '../context/CurrencyContext';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CurrencyProvider data-id="element-186">
      <main className="min-h-screen bg-[#FDFBF7]" data-id="element-187">
        <HeroSection data-id="element-188" />
        <LeadSection data-id="element-189" />
        <PainSection data-id="element-190" />
        <TwistSection data-id="element-191" />
        <BenefitsSection data-id="element-192" />
        <CTASection data-id="element-193" />
        <Footer data-id="element-194" />
      </main>
    </CurrencyProvider>;
}